if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading-overlay__spinner')) {
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        const BRINDE_VARIANT_ID = 43446722035774; 
        const formData = new FormData(this.form);
        const variantIdComprada = parseInt(formData.get('id'));
        const quantidade = parseInt(formData.get('quantity') || 1);

        try {
          // 1. Verifica os itens atuais do carrinho
          const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
          const cartData = await cartRes.json();
          const jaTemBrinde = cartData.items && cartData.items.some(item => item.id === BRINDE_VARIANT_ID);

          let itemsParaAdicionar = [];

          // Regra: Adiciona o brinde APENAS se o cliente ainda NÃO tiver o brinde no carrinho
          if (variantIdComprada !== BRINDE_VARIANT_ID && !jaTemBrinde) {
            itemsParaAdicionar = [
              { id: variantIdComprada, quantity: quantidade },
              { id: BRINDE_VARIANT_ID, quantity: 1 }
            ];
          } else {
            itemsParaAdicionar = [{ id: variantIdComprada, quantity: quantidade }];
          }

          // 2. Adiciona os itens no carrinho
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsParaAdicionar })
          });

          // 3. Busca o HTML atualizado da gaveta
          const responseSections = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
          const sectionsData = await responseSections.json();

          // 4. Injeta o HTML retornado na gaveta do tema
          if (this.cart && sectionsData['cart-drawer']) {
            const parser = new DOMParser();
            const parsedHTML = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
            const drawerElement = document.querySelector('cart-drawer');
            
            if (drawerElement) {
              drawerElement.innerHTML = parsedHTML.querySelector('cart-drawer').innerHTML;
              drawerElement.classList.remove('is-empty');
              drawerElement.open(this.submitButton);
            }
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }

        } catch (e) {
          console.error('Erro ao atualizar o carrinho:', e);
          this.form.submit();
        } finally {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          if (this.querySelector('.loading-overlay__spinner')) {
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}